/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  HTTPValidationError,
  WithdrawalPage,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    WithdrawalPageFromJSON,
    WithdrawalPageToJSON,
} from '../models/index';

export interface CalculateAssignedWithdrawalReportRequest {
    dataAsOfDate: string;
}

export interface GetWithdrawalRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

/**
 * 
 */
export class WithdrawalApi extends runtime.BaseAPI {

    /**
     * Calculates and persists the assigned withdrawal report
     */
    async calculateAssignedWithdrawalReportRaw(requestParameters: CalculateAssignedWithdrawalReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.dataAsOfDate === null || requestParameters.dataAsOfDate === undefined) {
            throw new runtime.RequiredError('dataAsOfDate','Required parameter requestParameters.dataAsOfDate was null or undefined when calling calculateAssignedWithdrawalReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/withdrawal/assigned-withdrawal-report/{data_as_of_date}`.replace(`{${"data_as_of_date"}}`, encodeURIComponent(String(requestParameters.dataAsOfDate))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Calculates and persists the assigned withdrawal report
     */
    async calculateAssignedWithdrawalReport(requestParameters: CalculateAssignedWithdrawalReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.calculateAssignedWithdrawalReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve withdrawals with the specified filters.
     */
    async getWithdrawalRaw(requestParameters: GetWithdrawalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WithdrawalPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/withdrawal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WithdrawalPageFromJSON(jsonValue));
    }

    /**
     * Retrieve withdrawals with the specified filters.
     */
    async getWithdrawal(requestParameters: GetWithdrawalRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WithdrawalPage> {
        const response = await this.getWithdrawalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update withdrawal cache
     */
    async invalidateWithdrawalCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/withdrawal-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update withdrawal cache
     */
    async invalidateWithdrawalCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateWithdrawalCacheRaw(initOverrides);
        return await response.value();
    }

}
